export default "__VITE_ASSET__1b369ac6__"